import React from "react";
import PropTypes from "prop-types";

export const CategoryCarouselTile = ({ label, link, image }) => {
  return (
    <div className="category-tile category">
      <div className="lh0">
        {image ? (
          <img
            className="category-tile-img"
            src={image}
            loading={"lazy"}
            alt={label}
            width="255"
            height="255"
          />
        ) : (
          <div className="category-tile-fake-img"></div>
        )}
      </div>

      <h4 className="category-tile-title">
        <a href={link} className="stretched-link"
           onClick={(event) => {
               appData.actionTrigger.dispatch({
                   trigger: "handleClickCategory",
                   payload: {
                       eventLabel: label,
                       eventAction: 'categorie niv3 '

                   }
               });
           }}>
          {label}
        </a>
      </h4>
    </div>
  );
};

CategoryCarouselTile.propTypes = {
  label: PropTypes.string,
  link: PropTypes.string,
  image: PropTypes.string,
};

CategoryCarouselTile.defaultProps = {
  label: null,
  link: null,
  image: null,
};
